import { z } from "zod";
import { localDateSchema, timestampSchema, uuidSchema } from "../common/primitives.js";
import { washActivationStatusSchema, washProgramKindSchema } from "./enums.js";
/**
 * Müşteri uygulaması (sürücü) — abonelik hakkıyla uzaktan yıkama başlatma (Prompt 18, ADR 0018 §9, §19). Uygulamada
 * ÖDEME YOK: yalnızca geçerli abonelik hakkı. Sürücü kiracı seçmez; kiracı ve istasyon istekte açıkça verilir ve
 * sürücünün o kiracının müşteri profiline BAĞLI olması gerekir.
 */
export const driverWashOptionsQuerySchema = z.object({ tenantId: uuidSchema, stationId: uuidSchema });
export const driverWashOptionsSchema = z.object({
    stationId: uuidSchema,
    stationName: z.string(),
    /** İstasyonun yıkama başlatabilen ajanı çevrimiçi mi (değilse başlatma "istasyona ulaşılamıyor" döner). */
    reachable: z.boolean(),
    units: z.array(z.object({
        unitId: uuidSchema,
        name: z.string(),
        unitType: z.enum(["TUNNEL", "ROLLOVER", "SELF_SERVICE_BAY", "HAND_WASH"]),
        programs: z.array(z.object({
            programId: uuidSchema,
            code: z.string(),
            name: z.string(),
            kind: washProgramKindSchema,
            durationSeconds: z.number().int().nullable(),
        })),
    })),
    subscriptions: z.array(z.object({
        subscriptionId: uuidSchema,
        planCode: z.string(),
        planName: z.string(),
        periodEnd: localDateSchema.nullable(),
        remainingQuantity: z.string(),
        dailyLimit: z.string().nullable(),
        usedToday: z.string(),
        vehicleId: uuidSchema.nullable().describe("Araca bağlı abonelikte yalnızca bu araçla kullanılır"),
        coveredProgramIds: z.array(uuidSchema).describe("Bu istasyonda aboneliğin kapsadığı programlar"),
    })),
});
export const driverWashStartSchema = z.object({
    tenantId: uuidSchema,
    stationId: uuidSchema,
    unitId: uuidSchema,
    programId: uuidSchema,
    subscriptionId: uuidSchema,
    vehicleId: uuidSchema.nullable().default(null).describe("Araca bağlı abonelikte zorunlu (sürücünün aracı)"),
    activationId: uuidSchema
        .optional()
        .describe("İstemcinin ürettiği UUID (idempotency): aynı kimlikle yinelenen istek yeni başlatma yapmaz, mevcut kaydı döner"),
});
export const driverWashActivationSchema = z.object({
    id: uuidSchema,
    stationId: uuidSchema,
    unitId: uuidSchema.nullable(),
    programId: uuidSchema,
    subscriptionId: uuidSchema.nullable(),
    status: washActivationStatusSchema,
    expiresAt: timestampSchema.nullable(),
    failureReason: z.string().nullable(),
    createdAt: timestampSchema,
    startedAt: timestampSchema.nullable(),
    finishedAt: timestampSchema.nullable(),
});
export const driverWashActivationQuerySchema = z.object({ tenantId: uuidSchema });
//# sourceMappingURL=driver.js.map